import React, {useImperativeHandle, useRef} from "react";
import styled from "styled-components";
import colors from "../../const/style/colors";
import SlideThumbItem from "./SlideThumbItem";
import DOWNLOAD_IMAGE from "../../assets/img/download/ic_file_download_24px.svg";
import DOWNLOAD_HOVER_IMAGE from "../../assets/img/download/ic_file_download_hover_24px.svg";
import {IPTImage} from "../../interfaces/IPTInformation";

const HANDLE_SCROLL_EXTRA_MARGIN_TOP = 50;

const StyledRootDiv = styled.div`
    border: 1px solid #D8D8D8;
    position: relative;
    background:${colors.CF7F7F7};
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    padding-right:8px;
    padding-top:14px;
    padding-bottom:13px;
    overflow-y:auto;
    /* border-left:none; */
    /* border-bottom:none; */
    .ol-thumbs {
        padding-right: 9px;
        position: relative;
        height:100%;
        counter-reset: slide;
        overflow-y:auto;
    }
`;

const StyledDownloadFrame = styled.a`
    position: absolute;
    bottom: 20px;
    left: 20px;
    z-index: 10;
    padding: 7px 10px;
    border: 1px solid #5F5CFE;
    background: rgba(255, 255, 255);
    border-radius: 5px;
    box-shadow: 0px 3px 6px #00000043;
    
    :hover {
        background: #5F5CFE;
    }
    :hover img {
        content: url(${DOWNLOAD_HOVER_IMAGE});
    }
`;

interface ISlideThumbListProps {
    className?: string;
    images: ReadonlyArray<IPTImage>;
    onClickSlide?: (ptImage: IPTImage, index: number) => void;
    playingIndex?: number;
    tempSelectedIndex?: number;
    srcURLPrefix?: string;
    downloadUrl?: string;
    fileName?: string
}

export interface ISlideThumbListHandle {
    scrollToIndex: (index: number) => void;
}

const SlideThumbList = React.forwardRef<ISlideThumbListHandle, ISlideThumbListProps>(({
                                                                                          className,
                                                                                          images,
                                                                                          onClickSlide,
                                                                                          playingIndex,
                                                                                          tempSelectedIndex,
                                                                                          srcURLPrefix,
                                                                                          downloadUrl,
                                                                                          fileName
                                                                                      }, ref) => {

    const olThumbsRef = useRef<HTMLOListElement>(null);


    useImperativeHandle(ref, () => ({
        scrollToIndex: index => {
            const olThumbsDom = olThumbsRef.current;
            const destThumbItemDom = olThumbsDom?.querySelector<HTMLLIElement>(`li:nth-child(${index})`);
            if (!olThumbsDom || !destThumbItemDom) {
                return;
            }
            olThumbsDom.scrollTo({
                top: destThumbItemDom.offsetTop - HANDLE_SCROLL_EXTRA_MARGIN_TOP,
                behavior: 'smooth',
            });
        }
    }));

    return (
        <StyledRootDiv className={className}>
            <ol ref={olThumbsRef} className='ol-thumbs'>
                {images.map((ptImage, slideIndex) => (
                    <SlideThumbItem
                        key={slideIndex}
                        image={ptImage}
                        alt={`썸네일 #${slideIndex + 1}`}
                        tempSelected={tempSelectedIndex === slideIndex}
                        playing={playingIndex === slideIndex}
                        srcURLPrefix={srcURLPrefix}
                        onClick={() => onClickSlide?.(ptImage, slideIndex)}
                    />
                ))}
            </ol>
            {
                !downloadUrl ||
                downloadUrl.indexOf("-1") > 0 ||
                <StyledDownloadFrame href={downloadUrl} download={fileName + ".pdf"}>
                    <img src={DOWNLOAD_IMAGE} alt=""/>
                </StyledDownloadFrame>
            }
            {/*<StyledDownloadImage src={iconZoomIn}></StyledDownloadImage>*/}
        </StyledRootDiv>
    )
});

export default SlideThumbList;
